import { Component, computed, input } from '@angular/core';
import { ButtonType } from '../button.component';
import { provideIcons } from '@ng-icons/core';
import { IconComponent } from 'app/shared/icon/icon.component';
import { heroPlusMini } from '@ng-icons/heroicons/mini';

export type TextButtonColor = 'blue' | 'blueLight';

@Component({
  selector: 'button[appTextButton]',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './text-button.component.html',
  styles: ``,
  providers: [
    provideIcons({
      heroPlusMini,
    }),
  ],
  host: {
    '[class]': 'class()',
  },
})
export class TextButtonComponent {
  buttonType = input<ButtonType>();
  color = input('blueLight', { transform: (value: TextButtonColor | undefined) => (value ? value : 'blueLight') });

  class = computed(() => `${this.classes[this.color()]}`);
  classes: { [key in TextButtonColor]: string } = {
    blue: 'text-blue',
    blueLight: 'text-blue-light',
  };

  get isCreate(): boolean {
    return this.buttonType() === 'create';
  }
}
